import { FunctionComponent } from 'react';
import { Text, Modal, Button } from '@rsos/components/capstone/base';
import {
  ModalBody,
  ModalHeader,
  ModalFooter,
} from '@rsos/components/capstone/base/Modal/ModalComponents';
import { formatInternationalPhoneNumberHuman } from '@rsos/utils/internationalPhoneNumberUtils';

/**
 * Modal for ending a Text-From-911 conversation
 * @param {String} callerID - Phone number associated with
 * the conversation
 * @param {Boolean} isLoading - Loading state for ending the chat
 * @param {Boolean} isOpened - Flag for is the modal opened
 * @param {Function} onClose - Callback function for closing the modal
 * @param {Function} endChat - Callback function for confirming end conversation
 */

interface Props {
  callerID: string;
  isLoading: boolean;
  isOpened: boolean;
  onClose: () => void;
  endChat: () => void;
}

const TF911EndChatModal: FunctionComponent<Props> = ({
  callerID,
  isLoading,
  isOpened,
  onClose,
  endChat,
}) => {
  const displayPhoneNumber = formatInternationalPhoneNumberHuman(callerID);
  return (
    <Modal
      isOpened={isOpened}
      onClose={onClose}
      width={350}
      id="modal-end-text-from-911-conversation"
    >
      <ModalHeader onClose={onClose}>
        <Text size="xlarge" fontWeight="semibold" color="secondaryText" mb={15}>
          End Chat with {displayPhoneNumber}?
        </Text>
      </ModalHeader>
      <ModalBody>
        <Text size="normal" color="secondaryText">
          No additional messages will be sent for this incident.
        </Text>
      </ModalBody>
      <ModalFooter flow={12} justify="center">
        <Button btnType="tertiary" grow onClick={onClose}>
          Cancel
        </Button>
        <Button
          btnType="warning_primary"
          onClick={endChat}
          grow
          isLoadingProp={isLoading}
        >
          Confirm
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default TF911EndChatModal;
